
import React from 'react'
import AziendaFrom from '../../rightSidebar/AziendaFrom'
import { Box } from '@mui/material'
import './cantine.scss'
import CantineForm from './CantineForm'

export const CantineSidebar = ({ cantine, setCantine }) => {
    return (
        <Box className='customDrawer_container'>
            <Box className='boxContainer__head'>
                <h2 className="boxContainer__title">Registra una Cantina</h2>
            </Box>
            <CantineForm cantine={cantine} setCantine={setCantine} />
        </Box>
    )
}
